import { ITranslationEntry } from '../lang';

export const SV: ITranslationEntry = {
  translations: {
    notifications: 'Meddelanden',
    markAllAsRead: 'Markera alla som lästa',
    poweredBy: 'Använder',
    settings: 'Inställningar',
  },
  lang: 'sv',
};
